<nav class="navbar">
  <div class="navbar-container">
    <!-- Logo -->
    <div class="logo-section">
      <a routerLink="/" class="logo">
        <img src="Arkifi official logo icon.svg" alt="ArkifiHub" class="logo-icon" />
        <span class="logo-text">ArkifiHub</span>
      </a>
    </div>

    <!-- Search Bar -->
    <div class="search-section">
      <div class="search-container">
        <i class="pi pi-search search-icon"></i>
        <input 
          type="text" 
          pInputText 
          [ngModel]="searchQuery()"
          (ngModelChange)="searchQuery.set($event)"
          placeholder="Search stores..."
          class="search-input"
          (keyup.enter)="onSearch()"
        />
        @if (searchQuery()) {
          <button 
            type="button"
            class="clear-search"
            (click)="searchQuery.set('')"
          >
            <i class="pi pi-times"></i>
          </button>
        }
      </div>
    </div>

    <!-- Navigation Links -->
    <div class="nav-links">
      <a routerLink="/marketplace" class="nav-link" [routerLinkActive]="'active'">Discover</a>
      
      @if (isAuthenticated() && showCart()) {
        <div class="cart-section dropdown" [class.active]="showCartDropdown()">
          <button (click)="toggleCartDropdown()" class="nav-link cart-btn" title="Shopping Cart">
            <i class="pi pi-shopping-cart"></i>
            @if (cartCount() > 0) {
              <span class="cart-badge">{{ cartCount() }}</span>
            }
          </button>

          <!-- Cart Dropdown -->
          @if (showCartDropdown()) {
            <div class="cart-dropdown">
              <div class="cart-header">
                <h3>Shopping Cart</h3>
                <button class="close-btn" (click)="toggleCartDropdown()" type="button">
                  <i class="pi pi-times"></i>
                </button>
              </div>

              @if (cartItems().length > 0) {
                <div class="cart-items">
                  @for (item of cartItems().slice(0, 5); track item.id) {
                    <div class="cart-item">
                      <div class="item-image">
                        @if (item.image) {
                          <img [src]="item.image" [alt]="item.name" (error)="$event.target.src='/assets/placeholder-product.png'">
                        } @else {
                          <div class="placeholder-image">📦</div>
                        }
                      </div>
                      <div class="item-details">
                        <h4 class="item-name">{{ item.name }}</h4>
                        <p class="item-price">₦{{ item.price | number:'1.2-2' }}</p>
                        <div class="quantity-controls">
                          <button class="qty-btn" (click)="updateCartQuantity(item.productId, item.quantity - 1)" type="button">-</button>
                          <span class="quantity">{{ item.quantity }}</span>
                          <button class="qty-btn" (click)="updateCartQuantity(item.productId, item.quantity + 1)" type="button">+</button>
                        </div>
                      </div>
                      <button class="remove-btn" (click)="removeFromCart(item.productId)" type="button" title="Remove">
                        <i class="pi pi-trash"></i>
                      </button>
                    </div>
                  }
                </div>

                <div class="cart-footer">
                  <div class="cart-total">
                    <span>Total: ₦{{ cartTotal() | number:'1.2-2' }}</span>
                  </div>
                  <div class="cart-actions">
                    <button class="btn btn-outline clear-cart-btn" (click)="clearCart()" type="button" *ngIf="cartItems().length > 0">
                      Clear Cart
                    </button>
                    <button class="btn btn-primary checkout-btn" (click)="goToCheckout()" type="button">
                      Proceed to Checkout
                    </button>
                  </div>
                </div>
              } @else {
                <div class="empty-cart">
                  <i class="pi pi-shopping-cart" style="font-size: 3rem; color: #9ca3af; margin-bottom: 1rem;"></i>
                  <p>Your cart is empty</p>
                </div>
              }
            </div>
          }
        </div>
      }
      
      @if (!isAuthenticated()) {
        <button (click)="onSignIn()" class="nav-link sign-in-btn">Sign In</button>
        <button (click)="onRegister()" class="nav-link register-btn">Register</button>
      } @else {
        <div class="user-menu">
          <button (click)="goToProfile()" class="nav-link profile-btn">
            <i class="pi pi-user"></i>
            <span>Profile</span>
          </button>
          <button (click)="onLogout()" class="nav-link logout-btn">
            <i class="pi pi-sign-out"></i>
            <span>Logout</span>
          </button>
        </div>
      }
      
      <button (click)="onCreateStore()" class="nav-link nav-link-create" type="button">
        <i class="pi pi-plus"></i>
        <span>Create your store</span>
      </button>
    </div>
  </div>
</nav>